@import 'styles/mixins';
@import 'styles/variables';

.root {
  border-radius: 6px;
  @include shadow-3;
  background: var(--neutral-0);
  display: flex;
  align-items: center;
  padding: 2px;

  .buttonGroup {
    display: flex;
    align-items: center;
  }
}

.summary {
  display: flex;
  align-items: center;
}

.user {
  @include sm-medium;
  color: var(--neutral-90);
  margin-left: 4px;
}

.action {
  @include sm-medium;
  color: var(--neutral-40);
  display: flex;
  align-items: center;
  column-gap: 4px;
}
